
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMobileMenu } from "@/contexts/MobileMenuContext";

export const MobileMenuToggle = () => {
  const { isMenuOpen, toggleMenu } = useMobileMenu();
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleMenu();
  };

  return (
    <Button 
      onClick={handleClick} 
      variant="ghost"
      size="icon"
      className="inline-flex items-center justify-center rounded-full p-2 text-slate-gray-dark hover:bg-slate-gray-light/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-flame transition-colors md:hidden z-50 MobileMenuToggle" 
      aria-controls="mobile-menu" 
      aria-expanded={isMenuOpen}
      aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
      type="button"
    >
      <span className="sr-only">
        {isMenuOpen ? "Fechar menu" : "Abrir menu"}
      </span>
      {isMenuOpen ? (
        <X className="block h-5 w-5" aria-hidden="true" />
      ) : (
        <Menu className="block h-5 w-5" aria-hidden="true" />
      )}
    </Button>
  );
};
